import { Box, CircularProgress, Typography } from "@mui/material"

const LoadingAll = ({ text = 'Carregando dados...', size = '3rem', minWidth = 340, minHeight = 700 }) => {
    return <Box style={{ minWidth: minWidth, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div className="absolute top-[45%] flex flex-col justify-center items-center">
            <CircularProgress size={size} />
            <Typography style={{ marginTop: 15, fontSize: 13.2, color: '#969696' }}>{text}</Typography>
        </div>
    </Box>
}

export default LoadingAll;